import { render } from "./MoveAnimation.vue?vue&type=template&id=a1bbcb9e"
import script from "./MoveAnimation.vue?vue&type=script&lang=js"
export * from "./MoveAnimation.vue?vue&type=script&lang=js"

import "./MoveAnimation.vue?vue&type=style&index=0&id=a1bbcb9e&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__